<template>
  <div class="b2b-tabPane">
    <el-tabs v-model="activeValue" @tab-click="tabClick">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.label"
        :name="item.name"
      >
        <!-- 这里使用具名插槽处理 -->
        <slot :name="item.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: String,
      default: "first"
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeValue: this.active
    };
  },
  created() {
    var bus = this.$bus.$off("changeTab");
    if (bus) {
      bus.$on("changeTab", val => {
        if (val) this.activeValue = val;
      });
    }
  },
  methods: {
    tabClick() {
      this.$emit("updateActive", this.activeValue);
    }
  }
};
</script>

<style lang="scss">
.b2b-tabPane {
}
</style>
